import * as Sentry from "@sentry/browser"

const DSN = process.env.NEXT_PUBLIC_SENTRY_DSN

export function initSentry() {
  if (typeof window === "undefined") return
  if (process.env.NODE_ENV !== "production") return
  if (!DSN) return

  Sentry.init({
    dsn: DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENV || process.env.NODE_ENV,
    release: process.env.NEXT_PUBLIC_RELEASE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  })
}

export function captureError(error: unknown, context?: Record<string, string>) {
  if (context) {
    Sentry.withScope((scope) => {
      for (const [key, value] of Object.entries(context)) {
        scope.setExtra(key, value)
      }
      Sentry.captureException(error)
    })
  } else {
    Sentry.captureException(error)
  }
}
